import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=ef87b3c2&scoped=true&"
import script from "./personalCenter.vue?vue&type=script&lang=js&"
export * from "./personalCenter.vue?vue&type=script&lang=js&"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=ef87b3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef87b3c2",
  null
  
)

export default component.exports